import { SvgIcon, type SvgIconProps } from "@mui/material";
import type { ReactNode } from "react";
import { DocumentStatus } from "@types";
import { docStatusDictionary } from "src/utils/documents";

type DocumentStatusFileIconConfig = {
  children: ReactNode;
  color: string;
  displayName: string;
};

const createDocumentStatusFileIcon = ({
  children,
  color,
  displayName,
}: DocumentStatusFileIconConfig) => {
  const DocumentStatusFileIcon = ({
    style,
    ...props
  }: SvgIconProps) => (
    <SvgIcon
      {...props}
      style={{
        color,
        height: 16,
        width: 13,
        ...style,
      }}
      viewBox="0 0 16 20"
    >
      {children}
    </SvgIcon>
  );

  DocumentStatusFileIcon.displayName = displayName;

  return DocumentStatusFileIcon;
};

export const UnapprovedIcon = createDocumentStatusFileIcon({
  color: docStatusDictionary[DocumentStatus.UNAPPROVED].borderColor,
  displayName: "UnapprovedIcon",
  children: (
    <>
      <path
        d="M0 20V0H10L16 6V20H0ZM9 7V2H2V18H14V7H9Z"
        fill="currentColor"
      />
      <path
        d="M8 16.2C9.76 16.2 11.2 14.76 11.2 13C11.2 11.24 9.76 9.8 8 9.8C6.24 9.8 4.8 11.24 4.8 13C4.8 14.76 6.24 16.2 8 16.2ZM8 9C10.2 9 12 10.8 12 13C12 15.2 10.2 17 8 17C5.8 17 4 15.2 4 13C4 10.8 5.8 9 8 9ZM8.2 13.32L6.28 14.44L6 13.88L7.6 12.96V11H8.2V13.32Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ApprovedIcon = createDocumentStatusFileIcon({
  color: docStatusDictionary[DocumentStatus.LIVE].borderColor,
  displayName: "ApprovedIcon",
  children: (
    <>
      <path
        d="M0 20V0H10L16 6V20H0ZM9 7V2H2V18H14V7H9Z"
        fill="currentColor"
      />
      <path
        d="M11.7493 10.5997L6.54687 16.381L3.65619 13.7793L4.56624 12.7682L6.44575 14.4589L10.7373 9.68972L11.7493 10.5997Z"
        fill="currentColor"
      />
      <path
        d="M11.7493 10.5997L6.54687 16.381L3.65619 13.7793L4.56624 12.7682L6.44575 14.4589L10.7373 9.68972L11.7493 10.5997Z"
        stroke="currentColor"
      />
    </>
  ),
});

export const DraftIcon = createDocumentStatusFileIcon({
  color: docStatusDictionary[DocumentStatus.DRAFT].borderColor,
  displayName: "DraftIcon",
  children: (
    <>
      <path
        d="M0 20V0H10L16 6V20H0ZM9 7V2H2V18H14V7H9Z"
        fill="currentColor"
      />
      <path
        d="M8.80051 11.8333L9.16602 12.1989L5.6354 15.7222H5.27767V15.3644L8.80051 11.8333ZM10.2003 9.5C10.1031 9.5 10.002 9.53889 9.92814 9.61278L9.21657 10.3244L10.6747 11.7828L11.3863 11.0711C11.5379 10.9194 11.5379 10.6667 11.3863 10.5228L10.4764 9.61278C10.3986 9.535 10.3014 9.5 10.2003 9.5ZM8.80051 10.7406L4.5 15.0417V16.5H5.95813L10.2586 12.1989L8.80051 10.7406Z"
        fill="currentColor"
      />
    </>
  ),
});
